import Link from 'next/link';
import config from '../config';

export default function Footer() {
  return (
    <footer className="bg-[#004C8C] text-white mt-12">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">Water Damage Direct</h3>
            <p className="text-blue-100">
              Connecting you with trusted water damage restoration professionals in your area, 24/7.
            </p>
          </div>
          
          <div>
            <h4 className="font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link href="/" className="text-blue-100 hover:text-white">Home</Link></li>
              {/* Only show Find Contractors if doorway pages are enabled */}
              {config.features.enableDoorwayPages && (
                <li><Link href="/states" className="text-blue-100 hover:text-white">Find Contractors</Link></li>
              )}
              <li><Link href="/emergency" className="text-blue-100 hover:text-white">Emergency Guide</Link></li>
              {process.env.NEXT_PUBLIC_ENABLE_QUIZ === 'true' && (
                <li><Link href="/water-damage-action-plan" className="text-blue-100 hover:text-white">Water Damage Action Plan</Link></li>
              )}
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold mb-4">Resources</h4>
            <ul className="space-y-2">
              <li><Link href="/faq" className="text-blue-100 hover:text-white">FAQ</Link></li>
              <li><Link href="/about" className="text-blue-100 hover:text-white">About Us</Link></li>
              <li><Link href="/our-vetting-process" className="text-blue-100 hover:text-white">Our Vetting Process</Link></li>
              {config.features.enableBlog && (
                <li><Link href="/blog" className="text-blue-100 hover:text-white">Blog</Link></li>
              )}
              {config.features.enableFloodAlerts && (
                <li><Link href="/flood-alerts" className="text-blue-100 hover:text-white">Flood Alerts</Link></li>
              )}
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold mb-4 text-xl">Need Help?</h4>
            <p className="text-blue-100 mb-4">
              Have questions about water damage restoration or need help finding a contractor? Get in touch for assistance.
            </p>
            <Link 
              href="/contact" 
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-md transition duration-300 inline-block font-bold mb-4 shadow-lg transform hover:scale-105"
            >
              Send Us a Message
            </Link>
            <p className="text-sm text-blue-200 mb-4">Inquiries are typically answered within 24 hours</p>
            <div className="flex space-x-4 mt-6">
              {config.features.enableFacebookLink && (
                <a href="https://facebook.com/waterdamagedirect" target="_blank" rel="noopener noreferrer" className="text-blue-100 hover:text-white clickable">
                  <span className="sr-only">Facebook</span>
                  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                  </svg>
                </a>
              )}
              {config.features.enableTwitterLink && (
                <a href="https://twitter.com/waterdamagedir" target="_blank" rel="noopener noreferrer" className="text-blue-100 hover:text-white clickable">
                  <span className="sr-only">Twitter</span>
                  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                  </svg>
                </a>
              )}
            </div>
          </div>
        </div>
        
        <div className="border-t border-blue-800 mt-8 pt-6 text-center text-sm text-blue-300">
          <div className="mb-4">
            <Link href="/terms" className="text-blue-100 hover:text-white mx-2">Terms of Service</Link>
            <Link href="/privacy" className="text-blue-100 hover:text-white mx-2">Privacy Policy</Link>
          </div>
          <p>&copy; {new Date().getFullYear()} Water Damage Direct. All rights reserved.</p>
          <p className="mt-2">A service of Glass Hill Ventures, LLC</p>
        </div>
      </div>
    </footer>
  );
}